import { Sparkles } from "lucide-react";

const TopBanner = () => {
  return (
    <div className="bg-gradient-to-r from-primary via-teal-dark to-primary text-primary-foreground py-2 px-4 text-center">
      <div className="container flex items-center justify-center gap-2 text-sm">
        <Sparkles className="w-4 h-4 text-accent animate-pulse" />
        <span>
          <strong className="text-accent">New:</strong> Life Transformation Diagnostic Quiz now available!
        </span>
        <Sparkles className="w-4 h-4 text-accent animate-pulse" />
      </div>
    </div>
  );
};

export default TopBanner;
